import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { OperationalCharge } from '../../models/forwarding/operational-charge.model';

@Injectable({
  providedIn: 'root'
})
export class OperationalChargesService {
  private apiUrl = `${environment.apiUrl}/forwarding/operational-charges`;
  private chargesSubject = new BehaviorSubject<OperationalCharge[]>([]);
  public charges$ = this.chargesSubject.asObservable();

  constructor(private http: HttpClient) {
    this.loadCharges();
  }

  private loadCharges(): void {
    console.log('[OperationalChargesService] Loading charges from:', this.apiUrl);
    this.http.get<OperationalCharge[]>(this.apiUrl).subscribe({
      next: (charges) => {
        console.log('[OperationalChargesService] Successfully loaded charges from API:', charges.length);
        this.chargesSubject.next(charges);
      },
      error: (error) => {
        console.error('[OperationalChargesService] Error loading charges from API:', error);
        this.chargesSubject.next([]);
      }
    });
  }

  getCharges(): Observable<OperationalCharge[]> {
    return this.charges$;
  }

  getById(id: number): Observable<OperationalCharge> {
    return this.http.get<OperationalCharge>(`${this.apiUrl}/${id}`);
  }

  refresh(): void {
    console.log('[OperationalChargesService] Manual refresh triggered');
    this.loadCharges();
  }
}
